<div class="stars-container">
    @for (starIcon of starIcons(); track $index) {
        <warema-icon aria-hidden="true" class="star" [icon]="starIcon" />
    }
</div>

<div class="label">{{ ratingStars() }} / {{ ratingCount() }}</div>
